import * as jsxRuntime from "/codebuild/output/src2220648899/src/creator-platform/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment